import {
    ADD_OR_UPDATE_TRANSFER_TYPE_SUCCESS,
    ADD_OR_UPDATE_TRANSFER_TYPE_FAILED,
    RESET_OR_UPDATE_TRANSFER_TYPE,
    LOADING_OR_UPDATE_TRANSFER_TYPE,
    NETWORK_ERROR_OR_UPDATE_TRANSFER_TYPE
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAdminAddUpdateTransferType = () => {
    return { type: RESET_OR_UPDATE_TRANSFER_TYPE };
};

const adminAddUpdateTransferType = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_OR_UPDATE_TRANSFER_TYPE });
    await adminServices
        .post("addUpdateTransfertype", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch({ type: ADD_OR_UPDATE_TRANSFER_TYPE_SUCCESS, payload: res.data });
                    break;
                default:
                    dispatch({ type: ADD_OR_UPDATE_TRANSFER_TYPE_FAILED, payload: res.data });
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_OR_UPDATE_TRANSFER_TYPE,
                payload: err
            });
        });
};

export { resetAdminAddUpdateTransferType, adminAddUpdateTransferType };
